import { createAction } from '@reduxjs/toolkit';

import { PREMIUM_MEDIA_ACTIONS } from 'js/src/data/premium-media/premium-media-types';

export const receivePremiumMediaUsage = createAction<{
    credits: number;
}>(PREMIUM_MEDIA_ACTIONS.RECEIVE_PREMIUM_MEDIA_USAGE);

export const receivePremiumMediaStatus = createAction<{
    total_active_credit_availability: number;
    total_active_credit_expense: number;
}>(PREMIUM_MEDIA_ACTIONS.RECEIVE_PREMIUM_MEDIA_STATUS);
